import React, { useCallback } from 'react';
import useLocale from '@/hooks/useLocale';
import * as Styles from './CurrentSOInfo.styles';
import { useSelector } from 'react-redux';
import ContentSection from '@/pages/Products/VpsOciDetailPage/components/ContentSection';
import { getIconBySlug } from '@/pages/Products/VpsOciDetailPage/utils';

const CurrentSOInfoDetail = () => {
  const vpsOci = useSelector(state => state.vpsOci);
  const {
    management: managementList,
  } = (vpsOci && vpsOci.data) || {};
  const { productDetails: productDetailsLocale } = useLocale();
  const { store: storeLocale } = productDetailsLocale.vpsOci;

  const currentSOInfo = () => {
    const currentSo = managementList && (managementList.find(app => app.slug === 'so-apps'));
    const currentSoSlug = currentSo && currentSo.info ? currentSo.info : '';
    const currentSoVersion = currentSo && currentSo.version ? currentSo.version : '';

    if (!currentSoSlug) return null;

    const soItem = storeLocale.details.operationalSystems[currentSoSlug];
    const iconItem = getIconBySlug(currentSoSlug);

    return {
      name: soItem ? `${soItem.name} ${currentSoVersion}` : '',
      description: soItem ? soItem.description : '',
      icon: iconItem ? <Styles.CurrentSOTitleIcon src={iconItem} alt={currentSoSlug} data-testid={`vpsoci-templates-icon-${currentSoSlug}`} /> : null,
    };
  };

  const currentSOInfoData = currentSOInfo();
  if (!currentSOInfoData) return null;

  return (
    <Styles.CurrentSO data-testid="vpsoci-templates-current-so">
      <Styles.CurrentSOTitle data-testid="vpsoci-templates-current-so-name">
        {currentSOInfoData.icon}
        {currentSOInfoData.name}
      </Styles.CurrentSOTitle>
      <Styles.CurrentSODescription data-testid="vpsoci-templates-current-so-description">
        {currentSOInfoData.description}
      </Styles.CurrentSODescription>
    </Styles.CurrentSO>
  );
};

const CurrentSOInfo = () => {
  const vpsOci = useSelector(state => state.vpsOci);
  const {
    addons: addonsList, vps,
  } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { store: storeLocale } = productDetailsLocale.vpsOci;

  const getAddonIcon = useCallback((slug) => {
    const iconItem = getIconBySlug(slug);
    return iconItem ? <Styles.AddonsItemIcon src={iconItem} alt={slug} data-testid={`vpsoci-templates-icon-${slug}`} /> : null;
  }, []);

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <ContentSection
      testId="vpsoci-templates-current-so-container"
    >
      <Styles.Subtitle data-testid="vpsoci-templates-current-so-title">{storeLocale.currentSo.title}</Styles.Subtitle>

      <CurrentSOInfoDetail />

      {addonsList && addonsList.length > 0 && (
        <Styles.AddonsContainer data-testid="vpsoci-templates-addons-container">
          <Styles.AddonsTitle>{storeLocale.currentSo.addons.title}</Styles.AddonsTitle>
          <Styles.AddonsWrapper>
            <Styles.AddonsSubtitle data-testid="vpsoci-templates-addons-title">{storeLocale.currentSo.addons.application}</Styles.AddonsSubtitle>
            {addonsList.map(addon => (
              <Styles.AddonsItem key={addon.id} data-testid="vpsoci-templates-addons-item">
                {addon.slug && getAddonIcon(addon.slug)}
                {addon.name}
              </Styles.AddonsItem>
            ))}
          </Styles.AddonsWrapper>
        </Styles.AddonsContainer>
      )}
    </ContentSection>
  );
};

export default CurrentSOInfo;
